export default __webpack_public_path__ + "static/media/banner.95696862.png";